














import {Component, Emit, Prop, Vue} from "vue-property-decorator";
import { TaskContent } from "../../Classes/Entities/Chat/TaskContent";

@Component
export default class TalkThreadOverview extends Vue {
  @Prop() 
  public taskContent!:TaskContent;
  @Prop() 
  public functionId!: string;

  public created() {
    console.log(this.taskContent.postList.threadList);
  }

  public get threadList() {
    return this.taskContent.postList.threadList;
  }
}
